// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ProfileBlockWrapper_wrapper__3LlKy","title":"ProfileBlockWrapper_title__1j2VB"};